import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CookieCategory = ({ icon, title, description, cookies, required = false, defaultEnabled = true }) => {
  const [enabled, setEnabled] = useState(defaultEnabled);

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <div className="flex items-start justify-between p-5 bg-white">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
            <Icon name={icon} size={18} className="text-accent" />
          </div>
          <div>
            <div className="flex items-center gap-2 mb-1">
              <h3 className="font-semibold text-gray-900">{title}</h3>
              {required && (
                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full font-medium">Required</span>
              )}
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">{description}</p>
          </div>
        </div>
        <div className="ml-4 flex-shrink-0">
          {required ? (
            <div className="w-11 h-6 bg-accent rounded-full flex items-center justify-end px-1 cursor-not-allowed opacity-70">
              <div className="w-4 h-4 bg-white rounded-full shadow" />
            </div>
          ) : (
            <button
              onClick={() => setEnabled(!enabled)}
              className={`w-11 h-6 rounded-full transition-colors duration-200 flex items-center px-1 ${
                enabled ? 'bg-accent justify-end' : 'bg-gray-300 justify-start'
              }`}
              aria-label={`${enabled ? 'Disable' : 'Enable'} ${title}`}
            >
              <div className="w-4 h-4 bg-white rounded-full shadow transition-transform" />
            </button>
          )}
        </div>
      </div>

      {cookies?.length > 0 && (
        <div className="border-t border-gray-100 bg-gray-50">
          <div className="overflow-x-auto">
            <table className="w-full text-xs">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left px-5 py-2.5 font-semibold text-gray-600">Cookie Name</th>
                  <th className="text-left px-5 py-2.5 font-semibold text-gray-600">Provider</th>
                  <th className="text-left px-5 py-2.5 font-semibold text-gray-600">Purpose</th>
                  <th className="text-left px-5 py-2.5 font-semibold text-gray-600">Expiry</th>
                </tr>
              </thead>
              <tbody>
                {cookies?.map((cookie, idx) => (
                  <tr key={idx} className="border-b border-gray-100 last:border-0">
                    <td className="px-5 py-2.5 font-mono text-gray-800">{cookie?.name}</td>
                    <td className="px-5 py-2.5 text-gray-600">{cookie?.provider}</td>
                    <td className="px-5 py-2.5 text-gray-600">{cookie?.purpose}</td>
                    <td className="px-5 py-2.5 text-gray-600">{cookie?.expiry}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieCategory;
